import { Link } from "react-router-dom";
import { Text } from "../../../../components/common/typography";
import { AppRoutes } from "../../../../common/routes/app_routes";

interface ProductPurchaseTermsProps {
  /** Seller's delivery lead time in days from order confirmation; null when not set. */
  leadTimeDays?: number | null;
  /** Opens a channel to ask about delivery when the seller hasn't set a lead time. */
  onAskAboutDelivery?: () => void;
}

function formatLeadTime(days: number) {
  const whole = Math.ceil(days);
  return `Within ${whole} ${whole === 1 ? "day" : "days"} of order confirmation`;
}

/** Delivery and returns terms shown under the purchase actions on the product page. */
export function ProductPurchaseTerms({ leadTimeDays, onAskAboutDelivery }: ProductPurchaseTermsProps) {
  return (
    <div className="flex flex-col gap-1 rounded-2xl border border-borderDefault bg-bgLight p-5">
      <div data-testid="delivery-terms">
        <Text variant="bodyBold" tone="dark" inline>Delivery: </Text>
        {leadTimeDays ? (
          <Text variant="body" tone="body" inline>{formatLeadTime(leadTimeDays)}</Text>
        ) : (
          <>
            <button type="button" onClick={onAskAboutDelivery} disabled={!onAskAboutDelivery}>
              <Text variant="body" tone="dark" inline className="underline underline-offset-4">
                Contact us
              </Text>
            </button>
            <Text variant="body" tone="body" inline> for delivery estimates</Text>
          </>
        )}
      </div>
      <div data-testid="return-terms">
        <Text variant="bodyBold" tone="dark" inline>Returns: </Text>
        <Text variant="body" tone="body" inline>Subject to our </Text>
        <Link to={AppRoutes.RETURN_POLICY} target="_blank" rel="noopener noreferrer">
          <Text variant="body" tone="dark" inline className="underline underline-offset-4">
            return policy
          </Text>
        </Link>
      </div>
    </div>
  );
}
